import { useState, useCallback } from 'react';
import PortalIdParser from 'PortalIdParser';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { ButtonWrapper } from 'foundations-components/transitional/components/ButtonWrapper';
import { Link } from 'foundations-components/transitional/components/Link';
import useShouldDisplayTourLinkOnCampaignSelect from '../../hooks/useShouldDisplayTourLinkOnCampaignSelect';
import { StandaloneUsageTracker } from '../../utils/usageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CampaignSelectEmptyState = ({
  objectType,
  onClickCreate
}) => {
  const [portalId] = useState(() => PortalIdParser.get());
  const shouldDisplayTourLink = useShouldDisplayTourLinkOnCampaignSelect();
  const tourLinkTracker = useCallback(() => {
    StandaloneUsageTracker.track('Campaigns Lib', 'Campaign Select Interaction', {
      action: 'onboarding tour link clicked',
      assetType: objectType
    });
  }, [objectType]);
  return /*#__PURE__*/_jsxs(ButtonWrapper, {
    children: [/*#__PURE__*/_jsx(Button, {
      use: "tertiary",
      "data-test-id": "campaigns-select-empty-state",
      onClick: onClickCreate,
      marginBlockStart: "200",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "campaignSelect.emptyStateCreateCampaign"
      })
    }), shouldDisplayTourLink && /*#__PURE__*/_jsx(Link, {
      "data-test-id": "campaigns-select-onboarding-tour-link",
      external: true,
      onClick: tourLinkTracker,
      href: `/marketing/${portalId}/campaigns`,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "campaignSelect.emptyStateTakeOnboardingTour"
      })
    })]
  });
};
export default CampaignSelectEmptyState;